import { render, staticRenderFns } from "./ansFile.vue?vue&type=template&id=36e0e887&scoped=true"
import script from "./ansFile.vue?vue&type=script&lang=js"
export * from "./ansFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0e887",
  null
  
)

export default component.exports